import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { PublishModalContextProviderExternalProps } from '../src/PublishModalContext.tsx';

export const PublishModalMountPoint: LoadableType<
	{
		publishButtonDisabled: boolean | undefined;
		userViewingPreview?: boolean;
		isUnpublishedDraft: boolean;
		contentType: string;
		title: string | null;
		shouldShowWorldIcon: boolean;
		shouldShowFooterButtons?: boolean;
		onHoverPublish?: () => void;
	} & PublishModalContextProviderExternalProps
> = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PublishModalMountPoint" */ '../src/PublishModalMountPoint.tsx'
			)
		).PublishModalMountPoint;
	},
});
